/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReceiptPaymentType {
    CASH = 'cash',
    BANK_TRANSFER = 'bank_transfer',
    CARD = 'card',
    TICKET = 'ticket',
    SUBSCRIPTION = 'subscription',
    WEBPAY = 'webpay',
}
